import { render, staticRenderFns } from "./forwardfeishudialog.vue?vue&type=template&id=20748cd0&scoped=true"
import script from "./forwardfeishudialog.vue?vue&type=script&lang=js"
export * from "./forwardfeishudialog.vue?vue&type=script&lang=js"
import style0 from "./forwardfeishudialog.vue?vue&type=style&index=0&id=20748cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20748cd0",
  null
  
)

export default component.exports